import { ref, computed, onUnmounted } from "vue";
import { useIntervalWhenVisible } from "@/composables/useIntervalWhenVisible";

export function usePolling(fetchFn, { interval = 60000 } = {}) {
  const lastRefreshed = ref(null);
  // Reactive tick counter to force lastRefreshedText recomputation
  const tick = ref(0);

  const lastRefreshedText = computed(() => {
    // Access tick so Vue tracks it as a dependency
    void tick.value;
    if (!lastRefreshed.value) return "";
    const diff = Math.floor((Date.now() - lastRefreshed.value.getTime()) / 60000);
    if (diff < 1) return "just now";
    if (diff === 1) return "1 min ago";
    return `${diff} min ago`;
  });

  async function poll() {
    await fetchFn();
    lastRefreshed.value = new Date();
  }

  const { restart } = useIntervalWhenVisible(poll, interval);

  function refresh() {
    lastRefreshed.value = new Date();
    restart();
    fetchFn();
  }

  // Start the label ticker (updates "X min ago" every 30s)
  const tickTimer = setInterval(() => {
    tick.value++;
  }, 30000);

  onUnmounted(() => clearInterval(tickTimer));

  return { lastRefreshedText, lastRefreshed, refresh };
}
